import FeatureGates from '@atlaskit/feature-gate-js-client';

export const useIsStandardizedDwellEnabled = () => {
	return (
		FeatureGates.getExperimentValue<'control' | 'variation'>(
			'cc-content-types-content-dwell-accuracy',
			'cohort',
			'control',
		) !== 'control'
	);
};
